import { Injectable } from '@angular/core';
import { ApiService } from '../API/api.service';
import { Observable, BehaviorSubject } from 'rxjs';
import * as XLSX from 'xlsx';

@Injectable({
  providedIn: 'root'
})
export class HaccpService {

  constructor(public apiService: ApiService) { }

  private haccp = new BehaviorSubject({});
  private empty=new Object();

  currentEditHaccp = this.haccp.asObservable();

  emptyData(){
    this.haccp.next(this.empty)
  }
  editHaccpData(data: any) {
    this.haccp.next(data)
  }
  gethazardType(body: any): Observable<any> {
    return this.apiService.get('HazardTypes/getHazardTypes/' + body.company_id);
  }
  addHazardType(body: any): Observable<any> {
    return this.apiService.post('HazardTypes/addHazardType', body);
  }
  getTypeRecord(body: any): Observable<any> {
    return this.apiService.get('documentTypes/getTypeRecord/' + body.company_id);
    // return this.apiService.get('Hazards/getHazardCount/'+body.company_id);

  }
  getTypeProcedure(body: any): Observable<any> {
    return this.apiService.get('documentTypes/getTypeProcedure/' + body.company_id);
  }
  addHazard(body: any): Observable<any> {
    return this.apiService.post('Hazards/addHazard', body);
  }
  getHazardById(body: any): Observable<any> {
    return this.apiService.get('Hazards/getHazardById/' + body.id);
  }
  getAllHazards(body: any): Observable<any> {
    return this.apiService.post('Hazards/getAllHazards', body);
  }
  getHazardCount(body: any): Observable<any> {
    return this.apiService.get('Hazards/getHazardCount/' + body.company_id);
  }
  hazardSearch(body: any, title: any): Observable<any> {
    return this.apiService.post('Hazards/getAllHazards/' + title, body);
  }
  editHazard(body : any, param : any): Observable<any> {
    return this.apiService.put('Hazards/editHazard', param , body);
  }

  downloadTemplete(fileName) {
    const data = [{
      'Process_Material': null,
      'Hazard': null,
      'Hazard Type': null
    }];

    const workBook = XLSX.utils.book_new();
    const workSheet = XLSX.utils.json_to_sheet(data);

    XLSX.utils.book_append_sheet(workBook, workSheet, 'Hazard Plan');
    XLSX.writeFile(workBook, fileName+'.xlsx');
  }
}
